const ThemeTokens = {
    Defaults: {
        px: [5, null, 6, 8],
        py: [6, null, 8],
        borderColor: 'muted.50',
        bgColor: '#F7F7FE',
        mobileMenuBreakpoint: 'md',
        sidebarBreakpoint: 'xl',
        menuItemPaddingTop: 2,
    },
    AppNavigation: {
        accentColor: 'primary.500',
    },
    TenancyCard: {
        maxW: ['full', null, null, '50%'],
    },
    TenancyModal: {
        body: {
            py: '8%',
        },
    },
};

export { ThemeTokens };
